import { render, staticRenderFns } from "./SupplierGeneralEdit.vue?vue&type=template&id=88675214&scoped=true&"
import script from "./SupplierGeneralEdit.vue?vue&type=script&lang=js&"
export * from "./SupplierGeneralEdit.vue?vue&type=script&lang=js&"
import style0 from "./SupplierGeneralEdit.vue?vue&type=style&index=0&id=88675214&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88675214",
  null
  
)

export default component.exports